import { render, staticRenderFns } from "./_productions.vue?vue&type=template&id=4d082c61&scoped=true&"
import script from "./_productions.vue?vue&type=script&lang=js&"
export * from "./_productions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d082c61",
  null
  
)

export default component.exports